class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.querySelector("#CartDrawer-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#cart-icon-bubble");
		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");

		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(cartLink);
		});

		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
			this.setSummaryAccessibility(cartDrawerNote);

		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add("animate", "active");
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = this.classList.contains("is-empty")
					? this.querySelector(".drawer__inner-empty")
					: document.getElementById("CartDrawer");
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".drawer__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		document.body.classList.add("cart-overflow-hidden");

		if (!isSafari()) {
			document.body.classList.add("overflow-hidden");
		} else {
			document.body.classList.add("overflow-clip");
		}
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("cart-overflow-hidden");

		if (!isSafari()) {
			document.body.classList.remove("overflow-hidden");
		} else {
			document.body.classList.remove("overflow-clip");
		}

		setTimeout(() => {
			let notification = this.querySelector(".notification");

			if (notification) {
				const activeItem = this.querySelector(
					`.cart-item[data-product-id="${this.productId}"`
				);
				notification.classList.remove("notification-open");
				activeItem?.classList.remove("active");
			}
		}, 1000);
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute(
				"aria-controls",
				cartDrawerNote.nextElementSibling.id
			);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				!event.currentTarget.closest("details").hasAttribute("open")
			);
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector(".drawer__inner").classList.contains("is-empty") &&
			this.querySelector(".drawer__inner").classList.remove("is-empty");
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
			sectionElement.innerHTML = this.getSectionInnerHTML(
				parsedState.sections[section.id],
				section.selector
			);
		});

		let notification = this.querySelector(".notification");

		if (notification) {
			const activeItem = this.querySelector(
				`.cart-item[data-product-id="${this.productId}"`
			);
			notification.classList.add("notification-open");
			activeItem.classList.add("active");
		}

		setTimeout(() => {
			this.querySelector("#CartDrawer-Overlay").addEventListener(
				"click",
				this.close.bind(this)
			);
			this.open();
		});
	}

	getSectionInnerHTML(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: "cart-drawer",
				selector: "#CartDrawer",
			},
			{
				id: "cart-icon-bubble",
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: "cart-drawer",
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);

if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					"input",
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, {
							...fetchConfig(),
							...{ body },
						});
					}, ON_CHANGE_DEBOUNCE_TIMER)
				);
			}
		}
	);
}

/* ================================================
 * 配送日時指定.amp
 * カートドロワー再描画対策
 * ================================================ */

(() => {

  let savedDeliveryApp = null;

  let restoreTimer = null;


  /**
   * 配送日時指定の本体だけ保存
   *
   * checkout-wrapper は保存しない。
   * checkout-wrapper には購入ボタンまで
   * 含まれるため、重複の原因になる。
   */
  function saveDeliveryApp() {

    const app =
      document.querySelector(
        '#cart-delivery-datetime_embedded'
      );

    if (!app) return;


    savedDeliveryApp = app;

  }


  /**
   * 配送日時指定を復元
   */
  function restoreDeliveryApp() {

    const cartDrawer =
      document.querySelector(
        'cart-drawer'
      );

    if (!cartDrawer) return;


    /*
     * アプリがすでに再生成されているなら
     * そちらを採用
     */
    const currentApp =
      cartDrawer.querySelector(
        '#cart-delivery-datetime_embedded'
      );

    if (currentApp) {

      savedDeliveryApp =
        currentApp;

      return;

    }


    /*
     * 保存済みアプリがない
     */
    if (!savedDeliveryApp) return;


    const checkout =
      cartDrawer.querySelector(
        '#CartDrawer-Checkout'
      );

    if (!checkout) return;


    const cartCtas =
      checkout.closest(
        '.cart__ctas'
      );

    if (!cartCtas) return;


    /*
     * アプリのcheckout-wrapperが
     * すでに存在するか確認
     */
    let wrapper =
      cartCtas.querySelector(
        '.cart-delivery-datetime_checkout-wrapper'
      );


    /*
     * wrapperが無ければ作成
     */
    if (!wrapper) {

      wrapper =
        document.createElement(
          'div'
        );

      wrapper.className =
        'cart-delivery-datetime_checkout-wrapper';


      wrapper.style.display =
        'flex';

      wrapper.style.flexDirection =
        'column';

      wrapper.style.gap =
        '12px';

      wrapper.style.width =
        '100%';

      wrapper.style.alignItems =
        'stretch';


      /*
       * 新しいcheckoutの位置に
       * wrapperを設置
       */
      checkout.before(
        wrapper
      );

    }


    /*
     * 配送日時指定本体をwrapperへ
     */
    wrapper.appendChild(
      savedDeliveryApp
    );


    /*
     * 新しく生成された購入ボタンを
     * wrapper内に移動
     *
     * 重要：
     * 古い購入ボタンは保存していないので
     * 重複しない。
     */
    wrapper.appendChild(
      checkout
    );

  }


  /**
   * DOM更新完了後に復元
   */
  function scheduleRestore() {

    clearTimeout(
      restoreTimer
    );


    restoreTimer =
      setTimeout(() => {

        restoreDeliveryApp();

      }, 300);

  }


  function initDeliveryAppKeep() {

    const cartDrawer =
      document.querySelector(
        'cart-drawer'
      );

    if (!cartDrawer) return;


    /*
     * 初回表示時
     */
    saveDeliveryApp();


    const observer =
      new MutationObserver(() => {

        /*
         * アプリ自身が新しいDOMを
         * 生成してくれた場合
         */
        const newApp =
          cartDrawer.querySelector(
            '#cart-delivery-datetime_embedded'
          );


        if (newApp) {

          savedDeliveryApp =
            newApp;

          return;

        }


        /*
         * カート更新によって
         * アプリが消えている場合
         */
        scheduleRestore();

      });


    observer.observe(
      cartDrawer,
      {
        childList: true,
        subtree: true
      }
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initDeliveryAppKeep
    );

  } else {

    initDeliveryAppKeep();

  }

})();
// Delivery eligibility follows the latest server-rendered cart, not cached app DOM.
(() => {
  function initDeliveryCartSync() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    let previousKey = null;
    let previousBlocked = false;
    let timer;
    let recoveryTimer;
    let resetPending = false;
    const reopenKey = 'mb-delivery-reopen-cart';
    if (sessionStorage.getItem(reopenKey) === '1') {
      sessionStorage.removeItem(reopenKey);
      document.querySelector('#cart-icon-bubble')?.click();
    }

    // Theme-only recovery: leave vendor rendering and wording untouched.
    const recoveryStorageKey = 'mb-delivery-recovery-v1';
    let attemptedKey = null;
    let savedForm = null;
    let noteDraft;
    let lastInputAt = 0;
    const optionDrafts = new Map();
    const optionNames = ['attributes[明細・プライスタグ不要]', 'attributes[ショップバッグを希望しない]'];
    try {
      const saved = JSON.parse(sessionStorage.getItem(recoveryStorageKey) || 'null');
      if (saved && Date.now() - saved.at < 60000) {
        attemptedKey = saved.key;
        savedForm = saved;
      }
      sessionStorage.removeItem(recoveryStorageKey);
    } catch (_) { /* Storage unavailable: do not attempt automatic recovery. */ }
    function captureDraft(event) {
      const input = event.target;
      if (!(input instanceof Element)) return;
      if (input.id === 'CartDrawer-Note') noteDraft = input.value;
      if (optionNames.includes(input.name) && input.type === 'checkbox') optionDrafts.set(input.name, input.checked);
      lastInputAt = Date.now();
    }
    drawer.addEventListener('input', captureDraft, true);
    drawer.addEventListener('change', captureDraft, true);
    function restoreDraft() {
      if (!savedForm) return;
      const footer = drawer.querySelector('[data-mb-delivery-cart-key]');
      if (!footer || footer.dataset.mbDeliveryCartKey !== savedForm.key) { savedForm = null; return; }
      const fields = drawer.querySelectorAll('input[type="checkbox"]');
      fields.forEach(input => {
        if (!optionNames.includes(input.name) || !(input.name in savedForm.options)) return;
        input.checked = savedForm.options[input.name];
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      const note = drawer.querySelector('#CartDrawer-Note');
      if (note && typeof savedForm.note === 'string' && note.value !== savedForm.note) {
        note.value = savedForm.note;
        note.dispatchEvent(new Event('input', { bubbles: true }));
      }
      savedForm = null;
    }
    function scheduleRecovery(key, blocked) {
      clearTimeout(recoveryTimer);
      // Japanese domestic delivery only; do not disturb intentional locale hiding.
      if (document.documentElement.lang.split('-')[0] !== 'ja') return;
      recoveryTimer = setTimeout(function checkRecovery() {
        const footer = drawer.querySelector('[data-mb-delivery-cart-key]');
        if (!footer || footer.dataset.mbDeliveryCartKey !== key || previousKey !== key) return;
        if (!drawer.querySelector('.cart-item') || drawer.classList.contains('is-empty')) return;
        const notice = drawer.querySelector('#undeliverable-statement .delivery-caution__statement');
        const normal = drawer.querySelector('#delivery-datetime--isRender');
        const correct = blocked ? Boolean(notice && notice.textContent.trim()) : Boolean(normal && !notice);
        if (correct || attemptedKey === key) return;
        // Allow cart requests and typing to finish before any navigation.
        if (resetPending || drawer.querySelector('.cart__items--disabled') ||
            drawer.contains(document.activeElement) && document.activeElement.matches('input, textarea, select') ||
            Date.now() - lastInputAt < 1500) {
          recoveryTimer = setTimeout(checkRecovery, 500);
          return;
        }
        const options = {};
        drawer.querySelectorAll('input[type="checkbox"]').forEach(input => {
          if (optionNames.includes(input.name)) options[input.name] = optionDrafts.has(input.name) ? optionDrafts.get(input.name) : input.checked;
        });
        const state = { key, at: Date.now(), options };
        if (typeof noteDraft === 'string') state.note = noteDraft;
        try {
          sessionStorage.setItem(recoveryStorageKey, JSON.stringify(state));
          if (drawer.classList.contains('active')) sessionStorage.setItem(reopenKey, '1');
        } catch (_) { return; }
        attemptedKey = key;
        window.location.reload();
      }, 2500);
    }
    restoreDraft();
    function sync() {
      const footer = drawer.querySelector('[data-mb-delivery-cart-key]');
      if (!footer) return;
      const key = footer.dataset.mbDeliveryCartKey;
      const blocked = !!drawer.querySelector('.cart-item[data-mb-delivery-blocked="true"]');
      const app = drawer.querySelector('#cart-delivery-datetime_embedded');
      // Hidden controls must not submit an obsolete delivery choice.
      if (blocked && app) {
        app.querySelectorAll('input, select, textarea').forEach(control => {
          if (!control.disabled) {
            control.dataset.mbDeliveryDisabled = 'true';
            control.disabled = true;
          }
        });
      } else if (app) {
        app.querySelectorAll('[data-mb-delivery-disabled]').forEach(control => {
          control.disabled = false;
          delete control.dataset.mbDeliveryDisabled;
        });
      }
      if (key === previousKey) return;
      const wasBlocked = previousBlocked;
      previousKey = key;
      previousBlocked = blocked;
      clearTimeout(timer);
      clearTimeout(recoveryTimer);
      if (blocked) {
        resetPending = true;
        const checkout = drawer.querySelector('#CartDrawer-Checkout');
        if (checkout) checkout.disabled = true;
        fetch(routes.cart_update_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: {
            '配送日の指定': 'なし',
            '配送希望日': '指定なし',
            '配送時間帯': '指定なし'
          } })
        }).then(response => {
          if (!response.ok) throw new Error('Delivery attributes could not be reset');
          resetPending = false;
          const current = drawer.querySelector('#CartDrawer-Checkout');
          if (current) current.disabled = false;
        }).catch(() => {
          const notice = drawer.querySelector('.mb-delivery-unavailable-notice');
          if (notice) notice.textContent = '配送指定の解除に失敗しました。ページを再読み込みしてからお進みください。';
        });
      }
      timer = setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        scheduleRecovery(key, blocked);
      }, 350);
    }
    drawer.addEventListener('click', event => {
      if (resetPending && event.target.closest('#CartDrawer-Checkout')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    new MutationObserver(sync).observe(drawer, { childList: true, subtree: true });
    sync();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryCartSync);
  } else {
    initDeliveryCartSync();
  }
})();
